import { Create, Edit, SimpleForm, TextInput, SelectInput, DateTimeInput } from 'react-admin';
import { Box, Paper, Typography } from '@mui/material';
import { LocalOffer } from '@mui/icons-material';

const TIER_CHOICES = [
  { id: 'Organic', name: 'Organic' },
  { id: 'Preferred', name: 'Preferred' },
];

const STATUS_CHOICES = [
  { id: 'Active', name: 'Active' },
  { id: 'Expired', name: 'Expired' },
  { id: 'Cancelled', name: 'Cancelled' },
];

/**
 * Training Provider Promotion Create/Edit forms
 *
 * Domain: Skills Development > Training Provider Promotion
 * Description: Forms for creating and editing provider promotion tiers.
 * @see Documentation/Specification/020_Definitions/application-specific/hr/skills-development/TrainingProviderPromotion.md
 */
export const PromotionCreate = () => (
  <Create>
    <SimpleForm>
      <Paper variant="outlined" sx={{ p: 3, mb: 3 }}>
        <Typography variant="subtitle2" sx={{ mb: 2.5, color: 'primary.main', fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>
          <LocalOffer fontSize="small" /> Promotion Details
        </Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
          <TextInput source="trainingProvider.id" label="Training Provider ID" fullWidth />
          <SelectInput source="tier" choices={TIER_CHOICES} fullWidth defaultValue="Organic" label="Tier" />
          <DateTimeInput source="startDate" label="Start Date" fullWidth />
          <DateTimeInput source="endDate" label="End Date" fullWidth />
          <SelectInput source="status" choices={STATUS_CHOICES} fullWidth defaultValue="Active" label="Status" />
          <TextInput source="ofoCodes" label="OFO Codes (comma-separated)" fullWidth placeholder="e.g., 12345, 67890" />
        </Box>
      </Paper>
    </SimpleForm>
  </Create>
);

export const PromotionEdit = () => (
  <Edit>
    <SimpleForm>
      <Paper variant="outlined" sx={{ p: 3, mb: 3 }}>
        <Typography variant="subtitle2" sx={{ mb: 2.5, color: 'primary.main', fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>
          <LocalOffer fontSize="small" /> Promotion Details
        </Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
          <TextInput source="trainingProvider.id" label="Training Provider ID" fullWidth />
          <SelectInput source="tier" choices={TIER_CHOICES} fullWidth label="Tier" />
          <DateTimeInput source="startDate" label="Start Date" fullWidth />
          <DateTimeInput source="endDate" label="End Date" fullWidth />
          <SelectInput source="status" choices={STATUS_CHOICES} fullWidth label="Status" />
          <TextInput source="ofoCodes" label="OFO Codes (comma-separated)" fullWidth />
        </Box>
      </Paper>
    </SimpleForm>
  </Edit>
);
